<template>
  <ContentPage>
    <template #header>
      <Progress :step="3" :steps="5">
        <h2 class="py-1" style="line-height: 28px;">
          What property types<br>do you work on?
        </h2>
        <div class="my-2 mx-6" style="font-size: 14px">
          Check all that apply. (Selected items should be green.)  You can update these at any time on your "You" page. 
        </div>
      </Progress>
    </template>

    <v-form ref="form" @submit.prevent="submit">
      <div class="pt-5 pb-7 px-8 white rounded-lg d-flex flex-column justify-center">
        <v-checkbox
          v-model="allowed"
          ref="trad"
          label="Residential Homes"
          color="primary"
          value="traditional"
          @click="$refs.form.validate()"
          :rules="[at_least_one]"
          class="mt-2" hide-details validate-on-blur
        />
        <v-checkbox
          v-model="allowed"
          ref="mh"
          label="Mobile Homes"
          color="primary"
          value="mobile_home"
          @click="$refs.form.validate()"
          :rules="[at_least_one]"
          class="mt-2" hide-details validate-on-blur
        />
        <v-checkbox
          v-model="allowed"
          ref="rv"
          label="RV's"
          color="primary"
          value="rv"
          @click="$refs.form.validate()"
          :rules="[at_least_one]"
          class="mt-2" hide-details="auto" validate-on-blur
        />
      </div>
    </v-form>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="back">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import Progress from './progress'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WizardStepD',

  components: { ContentPage, Progress },

  data: () => ({
    allowed: [],
  }),

  computed: {
    ...mapGetters('wizard', ['progress']),

    // validations
    at_least_one() {
      return () => this.allowed.length > 0 || 'At least one item should be selected'
    },
  },

  methods: {
    ...mapActions('wizard', ['updateProgress']),

    back() {
      this.$router.replace( { name: 'wizardC' } )
    },

    invert(structures) {
      let res = [ 'mobile_home', 'rv', 'traditional' ]

      if (!structures) { return res }

      return res.filter(s => !structures.includes(s))
    },

    async submit() {
      if (this.$refs.form.validate()) {
        const changes = {
           pro: { excluded_structure_types: this.invert(this.allowed) },  
        }
        
        this.updateProgress(changes)
        this.$router.replace( { name: 'wizardE' } )
      }
    },

    // This awful shennanigan is to get past the fact that the submit button is in the,
    // footer, and thus outside the form.
    nextClick() {
      this.$refs.form.$el.dispatchEvent(new SubmitEvent('submit')) // eslint-disable-line no-undef
    },
  },

  created() {
    this.allowed = this.invert(this.progress?.pro?.excluded_structure_types)
  },
}
</script>
